import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Starter from './store/Starter';
import App from './App';

ReactDOM.render(
  <Starter>
    <Router>
      <App />
    </Router>
  </Starter>
  ,
  document.getElementById('root')
);